import Dots from '../Atoms/Loaders/Dots';
import { styled } from '../stitches.config';

function KexFallbackBlock() {
  return <StyledFallbackBlock>{/* <Dots /> */}</StyledFallbackBlock>;
}

const StyledFallbackBlock = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  wh: '100%',
});

export default KexFallbackBlock;
